import { Link } from 'react-router-dom';
import { styled } from 'styled-components';
import { motion } from 'framer-motion';
import { SwapChild } from '../../components';

/** Title Header */
export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spaceMd};

  p {
    padding: 0;
    text-align: center;
    font-size: 0.875rem;

    @media only screen and (min-width: ${props => props.theme.breakpoints.width.md}) {
      padding: 0 8rem;
    }
  }
`;

/** Nav */
const NavBackground = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const NavImage = styled(NavBackground)`
  background-image: url(${props => props.image});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  z-index: -2;
  transition: scale 0.25s ease-in-out;
`;

export const ImageOverlay = styled(NavBackground)`
  background-color: ${props => props.theme.backgroundColor};
  opacity: 0.5;
  z-index: -1;
  transition: background-color 0.35s ease-in-out, opacity 0.25s ease-in-out;
`;

export const NavLinkWrapper = styled(motion(Link))`
  --nav-height: 45vh;
  position: relative;

  height: var(--nav-height);
  width: calc(var(--nav-height) * (9 / 16));

  display: flex;
  justify-content: center;
  align-items: center;

  color: ${props => props.theme.textColor};
  font-size: ${props => props.theme.sizeH4};
  font-weight: ${props => props.theme.headerWeight};
  letter-spacing: ${props => props.theme.headerSpacing};
  text-transform: uppercase;
  z-index: 1;

  border-radius: ${props => props.theme.borderRadiusXl};
  overflow: hidden;
  transition: box-shadow 0.125s ease-in-out;

  &:before {
    position: absolute;
    top: calc(50% + (-1 * var(--nav-height)));
    left: calc(50% + (-1 * var(--nav-height)));
    width: calc(2 * var(--nav-height));
    height: calc(2 * var(--nav-height));
    border-radius: ${props => props.theme.borderFull};
    content: '';
    border: 1px solid ${props => props.theme.brand + props.theme.clear50};
    transform-origin: center center;
    transition: border 0.25s ease-in-out;
    z-index: -1;
    box-sizing: border-box;
  }

  ${SwapChild} svg {
    height: 100%;
    width: 100%;
  }

  &:hover {
    ${NavImage} {
      scale: 1.075;
    }
    ${ImageOverlay} {
      background-color: ${props => props.theme.brand};
    }
    ${SwapChild}:first-of-type {
      margin-top: -4em;
    }

    color: ${props => props.theme.foregroundColor};

    &:before {
      border-width: var(--nav-height);
    }
  }

  &:active {
    box-shadow: 0 0 0 4px ${props => props.theme.backgroundColor},
      0 0 0 6px ${props => props.theme.brand + props.theme.clear50};
  }

  @media only screen and (min-width: ${props => props.theme.breakpoints.width.sm}) {
    font-size: ${props => props.theme.sizeH3};
  }
`;

export const NavWrapper = styled.nav`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${props => props.theme.spaceLg};

  ${NavLinkWrapper}:first-of-type,
  ${NavLinkWrapper}:last-of-type, {
    --nav-height: 40vh;
  }
`;
